// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/aoneci/runner/work/source/packages/commerce/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/Loading/global';

export function getRoutes() {
  const routes = [
  {
    "authKey": "login",
    "path": "/login",
    "title": "Auth.title",
    "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/EntryPagesContainer'), loading: LoadingComponent})],
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Auth__Login' */'@/pages/Auth/Login'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "authKey": "select-organization",
    "path": "/select-organization",
    "title": "Auth.SelectOrganization.title",
    "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/EntryPagesContainer'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/ICP'), loading: LoadingComponent})],
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Auth__SelectOrganization' */'@/pages/Auth/SelectOrganization'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "authKey": "activation",
    "path": "/organization_activation/:ticket",
    "title": "Auth.TenantActivation.title",
    "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/EntryPagesContainer'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/AccountInfo'), loading: LoadingComponent})],
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Auth__TenantActivation' */'@/pages/Auth/TenantActivation'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "authKey": "join",
    "path": "/organization_join/:ticket",
    "title": "Auth.TenantJoin.title",
    "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/EntryPagesContainer'), loading: LoadingComponent})],
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Auth__TenantJoin' */'@/pages/Auth/TenantJoin'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "authKey": "input-authenticator",
    "path": "/input-authenticator",
    "title": "Auth.InputAuthenticator.title",
    "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/EntryPagesContainer'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/ICP'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/AccountInfo'), loading: LoadingComponent})],
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Auth__InputAuthenticator' */'@/pages/Auth/InputAuthenticator'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "authKey": "bind-authenticator",
    "path": "/bind-authenticator",
    "title": "Auth.BindAuthenticator.card.title",
    "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/EntryPagesContainer'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/ICP'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/AccountInfo'), loading: LoadingComponent})],
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Auth__BindAuthenticator__PreBind' */'@/pages/Auth/BindAuthenticator/PreBind'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "authKey": "confirm-authenticator",
    "path": "/confirm-authenticator",
    "title": "Auth.BindAuthenticator.card.title",
    "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/EntryPagesContainer'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/ICP'), loading: LoadingComponent})],
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Auth__BindAuthenticator__Bind' */'@/pages/Auth/BindAuthenticator/Bind'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "authKey": "maintenance",
    "path": "/maintenance",
    "exact": true,
    "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/EntryPagesContainer'), loading: LoadingComponent})],
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NotFound__Maintenance' */'@/pages/NotFound/Maintenance'), loading: LoadingComponent})
  },
  {
    "authKey": "redirect:order-management",
    "path": "/",
    "exact": true,
    "redirect": "/order-management"
  },
  {
    "authKey": "mainRoutes",
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__HeaderMenu' */'@/layouts/HeaderMenu'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/channel",
        "title": "Channel.title",
        "authKey": "channel",
        "routes": [
          {
            "authKey": "channel.miniapp.post",
            "title": "Channel.WeChatMiniProgramPost.title",
            "path": "/channel/wechat-miniprogram-post",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Channel__WeChatMiniProgramPost' */'@/pages/Channel/WeChatMiniProgramPost'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent})],
            "access": "canAccessOne",
            "notRenderOnMenu": true,
            "exact": true
          },
          {
            "authKey": "channel.miniapp.list",
            "title": "Channel.WeChatMiniProgramList.title",
            "path": "/channel/wechat-miniprogram-list",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Channel__WeChatMiniProgramList' */'@/pages/Channel/WeChatMiniProgramList'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent})],
            "access": "canAccessOne",
            "exact": true
          },
          {
            "authKey": "channel.website.post",
            "title": "Channel.WebsitePost.title",
            "path": "/channel/website-post",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Channel__WebsitePost' */'@/pages/Channel/WebsitePost'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent})],
            "access": "canAccessOne",
            "notRenderOnMenu": true,
            "exact": true
          },
          {
            "authKey": "channel.website.list",
            "title": "Channel.WebsiteList.title",
            "path": "/channel/website-list",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Channel__WebsiteList' */'@/pages/Channel/WebsiteList'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent})],
            "access": "canAccessOne",
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NotFound' */'@/pages/NotFound'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "title": "Product.title",
        "path": "/product",
        "authKey": "product",
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent})],
        "icon": {
          "category": "standard",
          "name": "product_item"
        },
        "routes": [
          {
            "authKey": "product.category",
            "title": "Product.classify.title",
            "path": "/product/category",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__Category' */'@/pages/Product/Category'), loading: LoadingComponent}),
            "hideBorder": true,
            "hideRadius": true,
            "isGroup": true,
            "exact": true
          },
          {
            "authKey": "product.category.detail",
            "title": "Product.classify.title",
            "path": "/product/category/:categoryId",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "notRenderOnMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__Category' */'@/pages/Product/Category'), loading: LoadingComponent}),
            "hideBorder": true,
            "hideRadius": true,
            "isGroup": true,
            "exact": true
          },
          {
            "authKey": "product.spu.basic.edit",
            "title": "Product.detail.edit.title",
            "path": "/product/spu/basic/:spuId",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__Management__SpuBasic' */'@/pages/Product/Management/SpuBasic'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "hideBorder": true,
            "exact": true
          },
          {
            "authKey": "product.spu.sku.edit",
            "title": "Product.detail.edit.title",
            "path": "/product/spu/sku/:spuId",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__Management__SpuSku' */'@/pages/Product/Management/SpuSku'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "hideBorder": true,
            "exact": true
          },
          {
            "authKey": "product.spu.attribute.edit",
            "title": "Product.detail.edit.title",
            "path": "/product/spu/attribute/:spuId",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__Management__SpuAttribute' */'@/pages/Product/Management/SpuAttribute'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "hideBorder": true,
            "exact": true
          },
          {
            "authKey": "product.spu.detail",
            "title": "Product.preview.title",
            "path": "/product/detail/:spuId",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "notRenderOnMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__Management__SpuDetail' */'@/pages/Product/Management/SpuDetail'), loading: LoadingComponent}),
            "hideBorder": true,
            "isGroup": true,
            "isSplit": true,
            "exact": true
          },
          {
            "authKey": "product.spu.list",
            "title": "Product.management.title",
            "path": "/product/management",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__Management' */'@/pages/Product/Management'), loading: LoadingComponent}),
            "hideBorder": true,
            "exact": true
          },
          {
            "authKey": "product.gift.basic.edit",
            "title": "Product.Gift.header.title",
            "path": "/product/gift/spu/basic/:spuId",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__Management__GiftBasic' */'@/pages/Product/Management/GiftBasic'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "hideBorder": true,
            "exact": true
          },
          {
            "authKey": "product.gift.sku.edit",
            "title": "Product.Gift.header.title",
            "path": "/product/gift/spu/sku/:spuId",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__Management__GiftSku' */'@/pages/Product/Management/GiftSku'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "hideBorder": true,
            "exact": true
          },
          {
            "authKey": "product.gift.detail",
            "title": "Product.Gift.detail.title",
            "path": "/product/gift/detail/:spuId",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__Management__GiftDetail' */'@/pages/Product/Management/GiftDetail'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "hideBorder": true,
            "isSplit": true,
            "exact": true
          },
          {
            "authKey": "product.spu.review",
            "title": "Product.review.list.title",
            "path": "/product/review",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__Review__List' */'@/pages/Product/Review/List'), loading: LoadingComponent}),
            "hideBorder": true,
            "exact": true
          },
          {
            "authKey": "product.spu.reviewDetail",
            "title": "Product.review.detail.title",
            "path": "/product/review/:reviewId",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "notRenderOnMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__Review__Detail' */'@/pages/Product/Review/Detail'), loading: LoadingComponent}),
            "hideBorder": true,
            "isGroup": true,
            "isSplit": true,
            "exact": true
          },
          {
            "title": "Product.purchase-limit.edit.title",
            "path": "/product/purchase-limit/edit/:spuId",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "notRenderOnMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__PurchaseLimit__Edit' */'@/pages/Product/PurchaseLimit/Edit'), loading: LoadingComponent}),
            "hideBorder": true,
            "isSplit": true,
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NotFound' */'@/pages/NotFound'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NotFound' */'@/pages/NotFound'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "title": "OrderManagement.title",
        "path": "/order-management",
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent})],
        "authKey": "order",
        "icon": {
          "category": "standard",
          "name": "orders"
        },
        "routes": [
          {
            "authKey": "order.list",
            "title": "OrderManagement.title",
            "path": "/order-management",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OrderManagement__index' */'@/pages/OrderManagement/index'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "isSplit": false,
            "exact": true
          },
          {
            "authKey": "order.detail",
            "title": "OrderManagement.OrderDetail.title",
            "path": "/order-management/order-detail/:id",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OrderManagement__OrderDetail' */'@/pages/OrderManagement/OrderDetail'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NotFound' */'@/pages/NotFound'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "title": "AfterSale.title",
        "path": "/after-sale",
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent})],
        "authKey": "aftersales",
        "icon": {
          "category": "standard",
          "name": "call_history"
        },
        "routes": [
          {
            "authKey": "aftersales.list",
            "title": "AfterSale.List.title",
            "path": "/after-sale",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AfterSale__index' */'@/pages/AfterSale/index'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "exact": true
          },
          {
            "authKey": "aftersales.detail",
            "title": "AfterSale.Detail.title",
            "path": "/after-sale/detail/:id",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AfterSale__Detail' */'@/pages/AfterSale/Detail'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NotFound' */'@/pages/NotFound'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "title": "CustomerManagement.title",
        "path": "/customer-management",
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent})],
        "authKey": "customer",
        "icon": {
          "category": "standard",
          "name": "customers"
        },
        "routes": [
          {
            "authKey": "customer.list",
            "title": "CustomerManagement.title",
            "path": "/customer-management",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CustomerManagement__index' */'@/pages/CustomerManagement/index'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "authKey": "customer.detail",
            "title": "CustomerManagement.CustomerDetail.title",
            "path": "/customer-management/customer-detail/:id",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CustomerManagement__CustomerDetail' */'@/pages/CustomerManagement/CustomerDetail'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "exact": true
          },
          {
            "authKey": "customer.list",
            "title": "CustomerManagement.block-list",
            "path": "/customer-management/block-list",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CustomerManagement__BlockList__index' */'@/pages/CustomerManagement/BlockList/index'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "authKey": "customer.list",
            "title": "CustomerManagement.block-list.import-record.title",
            "path": "/customer-management/block-list/import-record",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CustomerManagement__BlockListImportRecord__index' */'@/pages/CustomerManagement/BlockListImportRecord/index'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NotFound' */'@/pages/NotFound'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "authKey": "promotion",
        "path": "/promotion",
        "title": "Promotion.title",
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent})],
        "icon": {
          "category": "standard",
          "name": "promotion_segments"
        },
        "routes": [
          {
            "authKey": "promotion.list",
            "title": "Promotion.management.title",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "path": "/promotion",
            "notRenderOnMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Promotion__List' */'@/pages/Promotion/List'), loading: LoadingComponent}),
            "isSplit": false,
            "exact": true
          },
          {
            "authKey": "promotion.create",
            "title": "Promotion.patch.create.title",
            "path": "/promotion/create",
            "notRenderOnMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Promotion__Details__Edit' */'@/pages/Promotion/Details/Edit'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "authKey": "promotion.detail",
            "title": "Promotion.details.title",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "hideBorder": true,
            "path": "/promotion/detail/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Promotion__Details__View' */'@/pages/Promotion/Details/View'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "isGroup": false,
            "exact": true
          },
          {
            "authKey": "promotion.update",
            "title": "Promotion.patch.update.title",
            "path": "/promotion/:id",
            "notRenderOnMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Promotion__Details__Edit' */'@/pages/Promotion/Details/Edit'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NotFound' */'@/pages/NotFound'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "title": "Notification.title",
        "path": "/notification",
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent})],
        "authKey": "notification",
        "icon": {
          "category": "standard",
          "name": "events"
        },
        "routes": [
          {
            "authKey": "notification.store-list",
            "title": "Notification.notice.title",
            "path": "/notification/list",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Notification__Notice' */'@/pages/Notification/Notice'), loading: LoadingComponent}),
            "hideBorder": true,
            "isGroup": false,
            "exact": true
          },
          {
            "authKey": "notification.webhook.list",
            "title": "Webhook.WebhookList.title",
            "path": "/notification/webhooks",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Notification__Webhook__WebhookList' */'@/pages/Notification/Webhook/WebhookList'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/Access'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "access": "canAccessOne",
            "isSplit": false,
            "exact": true
          },
          {
            "authKey": "notification.webhook.post",
            "title": "Webhook.WebhookPost.title",
            "path": "/notification/webhook-post",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Notification__Webhook__WebhookPost' */'@/pages/Notification/Webhook/WebhookPost'), loading: LoadingComponent}),
            "access": "canAccessOne",
            "notRenderOnMenu": true,
            "isSplit": true,
            "exact": true
          },
          {
            "authKey": "notification.webhook.edit",
            "title": "Webhook.WebhookEdit.title",
            "path": "/notification/webhook-edit/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Notification__Webhook__WebhookPost' */'@/pages/Notification/Webhook/WebhookPost'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "access": "canAccessOne",
            "notRenderOnMenu": true,
            "isSplit": true,
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NotFound' */'@/pages/NotFound'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/integration",
        "exact": true,
        "redirect": "/integration/demandware",
        "notRenderOnMenu": true
      },
      {
        "title": "Integration.title",
        "path": "/integration",
        "icon": {
          "category": "standard",
          "name": "webcart"
        },
        "routes": [
          {
            "title": "Integration.demandware.title",
            "path": "/integration/demandware",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Integration__Demandware__Main' */'@/pages/Integration/Demandware/Main'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "isSplit": true,
            "exact": true
          },
          {
            "title": "Integration.demandware.task.create.title",
            "path": "/integration/demandware/create",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Integration__Demandware__CreateOrUpdateTask' */'@/pages/Integration/Demandware/CreateOrUpdateTask'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "isSplit": false,
            "exact": true
          },
          {
            "title": "Integration.demandware.task.update.title",
            "path": "/integration/demandware/:taskId",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Integration__Demandware__CreateOrUpdateTask' */'@/pages/Integration/Demandware/CreateOrUpdateTask'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "isSplit": false,
            "exact": true
          },
          {
            "title": "Integration.demandware.task.detail.title",
            "path": "/integration/demandware/task-detail/:taskId",
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/PageHeader'), loading: LoadingComponent})],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Integration__Demandware__TaskDetail' */'@/pages/Integration/Demandware/TaskDetail'), loading: LoadingComponent}),
            "notRenderOnMenu": true,
            "isSplit": true,
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NotFound' */'@/pages/NotFound'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NotFound' */'@/pages/NotFound'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NotFound' */'@/pages/NotFound'), loading: LoadingComponent}),
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
